/*
Item: Job Dialog component for exporting tables from Statistics.jsx
Name: JobDialog
Format: Code/Frontend component
*/
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { MultiLanguage } from '../../utils/MultiLanguage';

export default class JobTableDialog extends Component {
  constructor(props) {
    super(props);
    this.multiLanguage = new MultiLanguage();
    const { onHideJobTable, jobTable, manual } = this.props;
    this.onHideJobTable = onHideJobTable;
    this.jobTable = jobTable;
    this.manual = manual;
    this.state = {
      fileName: '',
    };
    this.jobOptions = [
      // { label: 'CSV', value: 'CSV_TABLE' },
      { label: 'Excel', value: 'XLSX' },
      { label: 'Flatfile', value: 'FLATFILECSV_TABLE' },
    ];
  }

  renderFooter() {
    const { fileName } = this.state;
    const regex = /^[^<>*!?^"':,/\\]+$/;
    const noValidFilename = fileName.search(regex) === -1;
    return (
      <div>
        <Button
          label="Durchführen"
          id="save"
          type="button"
          icon="pi pi-check"
          disabled={fileName === ''}
          onClick={() => {
            this.jobTable(
              fileName,
            );
          }}
          className="p-button-success"
        />
        <Button
          label="Abbrechen"
          id="abortSave"
          type="button"
          icon="pi pi-times"
          onClick={() => { this.onHideJobTable(); }}
          className="p-button-danger"
        />
      </div>
    );
  }

  render() {
    const { jobTableVisible } = this.props;
    const { fileName } = this.state;
    return (
      <div>
        <Dialog
          header="Werteabruf"
          visible={jobTableVisible}
          style={{ width: '50vw' }}
          footer={this.renderFooter()}
          onHide={this.onHideJobTable}
          modal
        >
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <p>{this.manual ? null : "Die Tabelle ist zu groß um im Browser ausgegeben zu werden. "}Soll der Werteabruf im Batch durchgeführt werden?</p>
              <p>{this.manual ? "G" : "Wenn ja, g"}eben Sie bitte Ihrem Auftrag einen Namen:</p>
            </div>
            <div className="p-col-12">
              <span className="md-inputfield">
                <InputText
                  maxLength="99"
                  id="fileName"
                  value={fileName || ''}
                  onChange={(e) => this.setState({ fileName: e.target.value })}
                />
                <label htmlFor="fileName">Auftragsname*</label>
              </span>
            </div>
          </div>
        </Dialog>
      </div >
    );
  }
}
